import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { UserIcon, Clock } from 'lucide-react';
const notifications = [{
  name: 'Carlos M.',
  district: 'San Miguel',
  minutes: 3
}, {
  name: 'María L.',
  district: 'Magdalena',
  minutes: 7
}, {
  name: 'Jorge R.',
  district: 'San Miguel',
  minutes: 12
}, {
  name: 'Andrea P.',
  district: 'Pueblo Libre',
  minutes: 15
}, {
  name: 'Luis F.',
  district: 'Jesús María',
  minutes: 22
}, {
  name: 'Camila S.',
  district: 'San Miguel',
  minutes: 28
}, {
  name: 'Diego V.',
  district: 'Breña',
  minutes: 35
}, {
  name: 'Valentina T.',
  district: 'Lince',
  minutes: 41
}];
export function FloatingNotification() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    // Show first notification after 4 seconds
    const initialTimer = setTimeout(() => setVisible(true), 4000);
    return () => clearTimeout(initialTimer);
  }, []);
  useEffect(() => {
    if (!visible) return;
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % notifications.length);
        setVisible(true);
      }, 600);
    }, 5000);
    return () => clearInterval(interval);
  }, [visible]);
  const current = notifications[currentIndex];
  return <div className="fixed bottom-6 left-4 md:left-6 z-40 pointer-events-none" data-id="element-73">
      <AnimatePresence data-id="element-74">
        {visible && <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} transition={{
        type: 'spring',
        damping: 20,
        stiffness: 300
      }} className="pointer-events-auto bg-gym-charcoal border border-gym-green/40 rounded-xl px-4 py-3 shadow-[0_4px_24px_rgba(16,185,129,0.15)] max-w-[280px] md:max-w-[320px]" data-id="element-75">
            <div className="flex items-center gap-3" data-id="element-76">
              <div className="w-10 h-10 rounded-full bg-gym-green/20 border border-gym-green/30 flex items-center justify-center shrink-0" data-id="element-77">
                <UserIcon size={20} className="text-gym-green" data-id="element-78" />
              </div>
              <div className="min-w-0" data-id="element-79">
                <p className="text-white text-sm font-semibold truncate" data-id="element-80">
                  {current.name}{' '}
                  <span className="text-gray-400 font-normal" data-id="element-81">
                    de {current.district}
                  </span>
                </p>
                <p className="text-gym-green text-xs font-medium" data-id="element-82">
                  reservó su clase gratis
                </p>
                <div className="flex items-center gap-1 mt-0.5" data-id="element-83">
                  <Clock size={10} className="text-gray-500" data-id="element-84" />
                  <span className="text-gray-500 text-[11px]" data-id="element-85">
                    hace {current.minutes} minutos
                  </span>
                </div>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}